import React, { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getDashboardURLS, setCurrentDashboard } from '../../actions/dashboard/Dashboard';
import Dashboard from '../../components/dashboard/Dashboard';
import { identityRegion, dashboardRegion } from '../../constants/Constants';
import { getAccessToken, getIdToken, searchData } from '../../utility/common';

// eslint-disable-next-line react/jsx-props-no-spreading
const ReportsContainer = (props) => {
  const [value, setValue] = useState(null);
  const [isSearchError, setSearchError] = useState(null);
  const { location, history } = props;
  const { state } = location;
  const dashboardData = useSelector((store) => store.getDashboardList);
  const {
    dashboardListData, isDLSending, dLError,
  } = dashboardData;
  // console.log(props);
  useEffect(() => {
    if (state && state.DashboardId) {
      setValue(null);
      const currentDashboard = state;
      props.setCurrentDashboard({ currentDashboard });
      const dashboardURLParams = {
        identityRegion,
        dashboardRegion,
        openIdToken: getIdToken(),
        accessToken: getAccessToken(),
        printEnabled: true,
        resetDisabled: false,
        undoRedoDisabled: false,
        dashboardId: state.DashboardId,
      };
      props.getDashboardURLS(dashboardURLParams);
    } else {
      // eslint-disable-next-line no-undef
      history.push({ pathname: '/home', hash: window.location.hash });
    }
  }, [location.state]);

  const dashboardUrl = useSelector((store) => store.getDashboardURLs);
  const { dasboardURLsData, isDURLsSending, uRLsError } = dashboardUrl;
  // eslint-disable-next-line consistent-return
  const handleSearch = (event, searchValue) => {
    // console.log(searchValue);
    setSearchError(false);
    setValue(searchValue);
    let currentDashboard = state;
    const dashboardURLParams = {
      identityRegion,
      dashboardRegion,
      openIdToken: getIdToken(),
      accessToken: getAccessToken(),
      printEnabled: true,
      resetDisabled: false,
      undoRedoDisabled: false,
      dashboardId: currentDashboard.DashboardId,
    };
    if (searchValue) {
      const searchReport = _.filter(searchData(dashboardListData), (elem) => elem.Name === searchValue.Name);
      if (searchReport <= 0) {
        setSearchError(true);
        return false;
      }
      currentDashboard = searchValue;
      dashboardURLParams.dashboardId = searchValue.DashboardId;
    }
    // console.log(currentDashboard);
    props.setCurrentDashboard({ currentDashboard });
    props.getDashboardURLS(dashboardURLParams);
  };

  const getSearchOptionsData = () => {
    let option = '';
    if (dashboardListData && Array.isArray(dashboardListData) && dashboardListData.length > 0) {
      option = searchData(dashboardListData);
    }
    return option;
  };
  const getCurrentDashboard = useSelector((store) => store.getCurrentDashboard);
  const { currentDashboard } = getCurrentDashboard;
  // console.log(currentDashboard);
  const { Name, description } = currentDashboard;
  return (
    <Dashboard
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      dashboardUrl={dasboardURLsData}
      isDLSending={isDLSending}
      dLError={dLError}
      isDURLsSending={isDURLsSending}
      uRLsError={uRLsError}
      dashboardListData={getSearchOptionsData()}
      handleSearch={(event, searchValue) => handleSearch(event, searchValue)}
      searchValue={value}
      isSearchError={isSearchError}
      reportName={Name}
      reportDesc={description}
    // reportDesc={`${Name} description`}
    />
  );
};

ReportsContainer.propTypes = {
  location: PropTypes.oneOfType([PropTypes.object]).isRequired,
  setCurrentDashboard: PropTypes.func.isRequired,
  getDashboardURLS: PropTypes.func.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const mapDispatchedToProps = {
  getDashboardURLS, setCurrentDashboard,
};

export default connect(null, mapDispatchedToProps)(ReportsContainer);
